<template>
  <b-button
    :variant="'primary'"
    class="add-button"
    :class="isDisabled ? 'disabled-add' : ''"
    :disabled="isDisabled"
  >
    <div class="d-flex align-items-center justify-content-center">
      <div v-if="isShowIcon">
        <icon-plus v-if="isIconPlus" />
        <add-icon v-else />
      </div>
      <span class="ml-2" v-if="btnLabel">{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";
import AddIcon from "@/@core/components/svg/button/Add.vue";
import IconPlus from "@/@core/components/svg/common/IconPlus.vue";

export default {
  components: {
    BButton,
    AddIcon,
    IconPlus,
  },
  props: {
    btnLabel: { type: String },
    isDisabled: { type: Boolean, default: false },
    isShowIcon: { type: Boolean, default: true },
    isIconPlus: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.add-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.8rem;
  font-size: 22px;
}

.add-button svg {
  width: 18px;
  fill: var(--button-primary-font);
}

.disabled-add svg {
  fill: #fff;
}

.add-button.disabled-add {
  background-color: #e3e3e3 !important;
  border-color: #e3e3e3 !important;
  color: #fff !important;
  opacity: unset !important;
}
</style>
